module.exports = require("./kok.js");